import React from 'react';
import { cn } from '@/lib/utils';
import { counterpartySideLabelFa, resolveCounterpartySide, type CounterpartySide } from '@/lib/counterpartySide';

type CounterpartySideBadgeProps = {
  debit: number;
  credit: number;
  side?: CounterpartySide | null;
  className?: string;
  /** وقتی طرف انتخاب شده ولی مبلغ نیست */
  pendingHint?: boolean;
};

const CounterpartySideBadge: React.FC<CounterpartySideBadgeProps> = ({
  debit,
  credit,
  side: sideProp,
  className,
  pendingHint,
}) => {
  const side = sideProp ?? resolveCounterpartySide(debit, credit);
  if (!side && !pendingHint) return null;

  if (!side && pendingHint) {
    return (
      <span className={cn('text-[10px] text-amber-700', className)}>نقش طرف: بدهکار یا بستانکار را پر کنید</span>
    );
  }

  if (!side) return null;

  const isDebit = side === 'debit';

  return (
    <span
      className={cn(
        'inline-flex rounded px-1.5 py-0.5 text-[10px] font-medium',
        isDebit ? 'bg-rose-100 text-rose-800' : 'bg-emerald-100 text-emerald-800',
        className,
      )}
      title={isDebit ? 'این شخص در بدهکار سند است' : 'این شخص در بستانکار سند است'}
    >
      طرف: {counterpartySideLabelFa(side)}
    </span>
  );
};

export default CounterpartySideBadge;
